import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { getToken, setToken, clearToken, setUnauthorizedHandler } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // user object when authenticated
  const [checked, setChecked] = useState(false); // true after initial /me check
  const [loading, setLoading] = useState(false);

  const logout = useCallback(() => {
    clearToken();
    setUser(null);
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      setUser(null);
    });
    const tok = getToken();
    if (!tok) { setChecked(true); return; }
    api.get("/auth/me")
      .then(r => setUser(r.data))
      .catch(() => { clearToken(); setUser(null); })
      .finally(() => setChecked(true));
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setToken(r.data.access_token);
      setUser(r.data.user);
      return { ok: true, user: r.data.user };
    } catch (e) {
      const detail = e?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : (Array.isArray(detail) ? detail.map(d => d.msg).join(", ") : "Falha no login");
      return { ok: false, error: msg };
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, checked, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
};
